import axios from 'axios'
import config from './config'
import XLSX from "xlsx";

export default {

    execute(file) {

        console.log("enter getsignedURL function")
        const formData = new FormData();
        formData.append('file', file);

        return axios.post(config.HEPDATAPORTAL_API_ENDPOINT + "getValidatedSignedUrlfdnofile", formData)
            .then((res) => {
                return Promise.resolve(res.data)
            })
            .catch((err) => {
                return Promise.reject("")
            });
    },

    /**
     * This function reads the Excel sheet ('Company Information') sheet 3
     * then check for cell D4 (ID) and N1 (REPORT YEAR),
     * if found and are valid values, put them in the array and return to the caller.
     * if no load_sheet found return the 'unknown'
     * if found but not valid values return 'invalid'
     * @param file
     */
    async readUploadFile(file) {
        return new Promise((resolve, reject) => {
            let result = [];
            let XLSX = require('xlsx');
            let reader = new FileReader()
            reader.onload = function (e) {
                try {
                    let data = e.target.result;
                    let workbook = XLSX.read(data, {type: 'binary'});
                    let sheetNames = workbook.SheetNames;
                    let companyInformationSheet = workbook.SheetNames[sheetNames.indexOf('Company Information')];

                    let ID_CELL = 'D4';
                    let REPORT_YEAR_CELL = 'N1';
                    //let PREMIUM_REVENUE = 'E19';
                    let FIRST_CELL = 'A1';
                    let FINANCIAL_LEVEL_CELL = 'M1';

                    let worksheet = workbook.Sheets[companyInformationSheet];
                    let docTitleCorrect = typeof(worksheet)!=='undefined' && worksheet!== null && worksheet[FIRST_CELL].v.includes("(HPFSR)");
                    let ID = (worksheet[ID_CELL] ? worksheet[ID_CELL].v : 0);

                    //let PREMIUM_REVENUE_CHECK = (worksheet[PREMIUM_REVENUE] ? worksheet[PREMIUM_REVENUE].v : 0);
                    let healthPlanIdSheet = workbook.SheetNames[sheetNames.indexOf('Health Plan_ID')];
                    let healthPlanIdWorksheet = workbook.Sheets[healthPlanIdSheet];

                    let firstHealthPlanIdCell = 'A2';
                    let lastHealthPlanIdCell = 'A' + (XLSX.utils.sheet_to_json(healthPlanIdWorksheet).length + 1).toString();
                    let healthPlanIds = XLSX.utils.sheet_to_json(healthPlanIdWorksheet, {range: firstHealthPlanIdCell + ":" + lastHealthPlanIdCell});
                    let healthPlanIdsArray = healthPlanIds.map(function (el) {
                        return el.Health_Plan_ID;
                    });

                    let REPORT_YEAR = (worksheet[REPORT_YEAR_CELL] ? worksheet[REPORT_YEAR_CELL].v : 0);
                    let isValidId = /^\d+$/.test(ID) && (ID > 0) && (ID.toString().length === 5 && healthPlanIdsArray.includes(ID));
                    let isValidYear = /^\d+$/.test(REPORT_YEAR) && (REPORT_YEAR > 0);

                    // Pull the Financial Level from Cell M1 - Company Information tab.
                    let FINANCIAL_LEVEL = (worksheet[FINANCIAL_LEVEL_CELL] ? worksheet[FINANCIAL_LEVEL_CELL].v : 0);
                    let isValidFinancialLevel = false;
                    if (FINANCIAL_LEVEL === 82 || FINANCIAL_LEVEL === 83 || FINANCIAL_LEVEL === 84 || FINANCIAL_LEVEL === 111) {
                        isValidFinancialLevel = true;
                    }

                    //let isValidRevenue = (/^\d{1,3}(,\d{3})*(\.\d+)?$/.test(PREMIUM_REVENUE_CHECK) || /^\d+/.test(PREMIUM_REVENUE_CHECK)) && (PREMIUM_REVENUE_CHECK >= 0);
                    //let companySheet = worksheet;
                    if (!docTitleCorrect && (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        || file.type === 'application/vnd.ms-excel')) {
                        let pushThis = 'unknown';
                        result.push(pushThis);
                    } else if (docTitleCorrect && isValidId && isValidYear && isValidFinancialLevel) {
                        result.push(ID); //result[0]
                        result.push(REPORT_YEAR); //result[1]
                        result.push(FINANCIAL_LEVEL); //result[2]
                    } else if (docTitleCorrect && (!isValidId || !isValidYear || !isValidFinancialLevel)
                        && (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            || file.type === 'application/vnd.ms-excel')) { // was excel file but wasn't the HCCIS template or it had issues
                        //ignore all if not found id or year
                        if (ID === 0 || REPORT_YEAR === 0 || FINANCIAL_LEVEL === 0) {
                            result.push('unknown');
                        } else {
                            result.push('invalid');
                            if (!isValidId) {
                                result.push('1');
                            } else {
                                result.push('9');
                            }
                            if (!isValidYear) {
                                result.push('2');
                            } else {
                                result.push('9');
                            }
                            if (!isValidFinancialLevel) {
                                result.push('3');
                            } else {
                                result.push('9');
                            }
                        }
                    }
                } catch (err) {
                    console.log(">>>> Company Information sheet not found!");
                    let pushItem = 'error';
                    if (file.type === 'application/pdf' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        || file.type === 'application/vnd.ms-excel') {
                        pushItem = 'unknown';
                    }
                    result.push(pushItem);
                }
                setTimeout(() => resolve(result), 60)
            }
            reader.readAsBinaryString(file);
        })
    }
}

